import { TickIcon } from '@fourthwall/icons';
import React from 'react';
import * as S from './Swatch.styled';
import isColorBright from './utils/isColorBright';
export const Swatch = ({ variant, fill, color, size, active, disabled = false, onClick, onMouseEnter, }) => {
    const isBright = isColorBright(fill);
    const detectedColor = isBright ? '#000' : '#fff';
    return (React.createElement(S.Swatch, { "$variant": variant, "$size": size, "$active": active, "$disabled": disabled, style: {
            color: color !== null && color !== void 0 ? color : detectedColor,
            background: fill,
        }, onClick: onClick, onMouseEnter: onMouseEnter },
        disabled && React.createElement(S.CrossOut, null),
        variant === 'checkable' && active && React.createElement(TickIcon, { width: 12 })));
};
//# sourceMappingURL=Swatch.js.map